import React from 'react';

const Calendly = (props) => (
    <div className="Calendly">
        <div className="container width-12 centerText">
            <h3 className="subTitleFont bold">Schedule a Call</h3>
        </div>
        <div className="calendly-inline-widget" data-url="https://calendly.com/candidgoat/discovery-call"></div>
        <a href="https://calendly.com/candidgoat/discovery-call" className="bodyFont button calendlyFailSafe" target="_blank" rel="noopener noreferrer">Becky's Calendar</a>
    </div>
)

export default Calendly;


// WEBPACK FOOTER //
// ./src/components/Calendly.js